import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalContainerComponent } from "../../../../domain/shared/component/modal-container/modal-container.component";
import { TeamTableComponent } from "../../../../domain/organization/component/team-table/team-table.component";
import { EmployeeDTO } from "../../../../domain/user/employee/dto/EmployeeDTO";
import { OrganizationDTO } from "../../../../domain/organization/dto/OrganizationDTO";
import { ButtonComponent } from "../../../../domain/shared/component/buttons/button.component";
import { EmployeeRole } from "../../../../domain/user/employee/dto/role-type";

@Component({
  selector: 'app-share-modal',
  imports: [
    ModalContainerComponent,
    TeamTableComponent,
    ButtonComponent,
  ],
  templateUrl: './share-modal.component.html',
  styleUrl: './share-modal.component.scss',
})
export class ShareModalComponent {
  protected readonly spinnerProps = {
    isSpinnerActive: true,
    notActiveOnApply: true,
  };

  @Input() employees: EmployeeDTO[];
  @Input({ required: true }) currentEmployee: EmployeeDTO;
  @Input() currentOrganization: OrganizationDTO;
  @Output() openInviteMemberModalEmitter = new EventEmitter<void>();
  @Output() closeButtonClickedEmitter = new EventEmitter<void>();
  @Output() deleteUserEmitter = new EventEmitter<EmployeeDTO>();
  @Output() resendInviteEmitter = new EventEmitter<EmployeeDTO>();
  @Output() updateRole =
    new EventEmitter<{employee: EmployeeDTO, role: EmployeeRole}>();
}
